import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { PropertyConstructionDto, PropertyDefinitionDto, PropertyType } from '@workspace/data-types';
import { EtxeEnumDisplayPipe } from '../../../pipes/etxe-enum-display.pipe';

@Component({
  selector: 'etxe-property-construction-display',
  standalone: true,
  imports: [CommonModule, MatIconModule, EtxeEnumDisplayPipe],
  templateUrl: './construction-display.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PropertyConstructionDisplayComponent {
  construction = input.required<PropertyConstructionDto>();
  propertyDefinition = input<PropertyDefinitionDto | null>(null);

  isHouse = computed(() => this.propertyDefinition()?.propertyType === PropertyType.HOUSE);

  viewsList = computed(() => {
    const v = this.construction()?.view;
    if (!v) return [];
    return Array.isArray(v) ? v : [v];
  });
}
